import { callFunction } from "./functions-client";

// Support tickets (user↔staff threads).
export const SUPPORT_CATEGORIES = ["help", "billing", "bug", "feature", "account", "other"] as const;
export const TICKET_PRIORITIES = ["low", "medium", "high", "urgent"] as const;
export const TICKET_STATUSES = ["open", "in_progress", "resolved", "closed"] as const;

export interface Ticket {
  id: string;
  subject: string;
  category: string;
  status: string;
  priority: string;
  assigned_to?: string | null;
  created_at: string;
  updated_at: string;
  resolved_at?: string | null;
  closed_at?: string | null;
  account_email?: string | null;
}
export interface TicketMessage {
  id: string;
  author_account_id: string;
  body: string;
  is_staff: boolean;
  internal?: boolean;
  created_at: string;
}

// --- user ---
export const createTicket = (input: { subject: string; body: string; category?: string }) =>
  callFunction<{ ticket_id: string }>("support/create", { body: input });
export const listTickets = (status?: string) =>
  callFunction<{ tickets: Ticket[] }>(`support/list${status ? `?status=${status}` : ""}`, { method: "GET" });
export const getTicket = (id: string) =>
  callFunction<{ ticket: Ticket; messages: TicketMessage[]; me: string }>(`support/get?id=${encodeURIComponent(id)}`, { method: "GET" });
export const replyTicket = (ticket_id: string, body: string) =>
  callFunction<{ ok: boolean }>("support/reply", { body: { ticket_id, body } });
export const closeTicket = (ticket_id: string) =>
  callFunction<{ ok: boolean }>("support/close", { body: { ticket_id } });

// --- staff (admin_support) ---
export const adminListTickets = (status?: string) =>
  callFunction<{ tickets: Ticket[]; counts: Record<string, number> }>(`support/admin-list${status ? `?status=${status}` : ""}`, { method: "GET" });
export const adminGetTicket = (id: string) =>
  callFunction<{ ticket: Ticket; messages: TicketMessage[]; me: string }>(`support/admin-get?id=${encodeURIComponent(id)}`, { method: "GET" });
export const adminReplyTicket = (ticket_id: string, body: string, internal = false) =>
  callFunction<{ ok: boolean }>("support/admin-reply", { body: { ticket_id, body, internal } });
export const adminUpdateTicket = (input: { ticket_id: string; status?: string; priority?: string; assigned_to?: string | null }) =>
  callFunction<{ ok: boolean }>("support/admin-update", { body: input });
